// eslint-disable-next-line
import "./styles.css";
import React, { Component } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Loader from "./components/common/loader";
import HomePiano from "./components/common/homePiano";
import Login from "./components/user/login";
import Register from "./components/user/register";
import Nav from "./components/common/navbar";
import { loggedIn } from "./services/auth";
import ForgotPassword from "./components/user/forgotPassword";
import VerifyAccount from "./components/user/verifyAccount";
import NotFound from "./components/common/notFound";

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Nav />
        <Routes>
          <Route
            path="/login"
            element={!loggedIn() ? <Login /> : <Navigate to="/" replace />}
          />
          <Route
            path="/register"
            element={!loggedIn() ? <Register /> : <Navigate to="/" replace />}
          />
          <Route
            path="/forgotPassword"
            element={
              !loggedIn() ? <ForgotPassword /> : <Navigate to="/" replace />
            }
          />
          <Route path="/verifyAccount" element={<VerifyAccountRoute />} />
          <Route path="/not-found" element={<NotFound />} />
          <Route
            path="/"
            element={
              loggedIn() ? <HomePiano /> : <Navigate to="/login" replace />
            }
          />
          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Routes>
        <Loader />
      </React.Fragment>
    );
  }
}

class VerifyAccountRoute extends Component {
  render() {
    const { location, ...props } = this.props;
    const email = new URLSearchParams(location.search).get("email");
    const hash = new URLSearchParams(location.search).get("hash");

    if (!email || !hash) {
      return <Navigate to="/" replace />;
    }

    return <VerifyAccount email={email} hash={hash} {...props} />;
  }
}

export default App;
